
import { defineComponent } from 'vue'

/**
 * JRQC用ボタン
 */
export default defineComponent({
  name: 'JrButtonForJrqc',
  emits: ['click'],
  setup(props, context) {
    return {
      click: () => {
        context.emit('click')
      },
    }
  },
})
